var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    attrs: {
      "width": "30",
      "height": "30",
      "viewBox": "0 0 30 30",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "15",
      "cy": "15",
      "r": "15",
      "fill": "#3C9EB7",
      "fill-opacity": "0.15"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M14.2387 15.04C13.6627 15.256 13.3507 15.736 13.3987 16.264L13.5907 17.776C13.6147 18.064 13.8547 18.28 14.1427 18.28H15.9667C16.2547 18.28 16.4947 18.064 16.5427 17.776L16.6387 17.008C16.6387 17.008 20.8627 16.048 20.8627 12.232C20.8627 9.208 18.2227 7 14.7667 7C12.1747 7 10.0867 8.248 9.10266 10.168C8.83866 10.624 9.10266 11.176 9.67866 11.32L11.2867 11.776C11.3587 11.8 11.4307 11.8 11.4787 11.8C11.7907 11.8 12.1027 11.632 12.3427 11.32C12.8467 10.6 13.7347 10.12 14.8147 10.12C16.3747 10.12 17.5987 11.032 17.5987 12.208C17.5987 13.744 15.4867 14.656 14.2387 15.04ZM13.2067 21.976C13.2067 23.032 13.9987 23.824 15.0547 23.824C16.1107 23.824 16.9027 23.032 16.9027 21.976C16.9027 20.92 16.1107 20.128 15.0547 20.128C13.9987 20.128 13.2067 20.92 13.2067 21.976Z",
      "fill": "#3C9EB7"
    }
  })]);

}
var staticRenderFns = []

export { render, staticRenderFns }